import { TrackingClient } from '../client'
export * from '../client'

if (window.__TRACKING_CLIENTS__) {
  window.__TRACKING_CLIENTS__.forEach((stubbedClient) => {
    stubbedClient.loaded(TrackingClient)
  })
}
